module.exports = __webpack_public_path__ + "static/img/under_construction.14b6d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/under_construction.png
// module id = 6Mq2
// module chunks = 7